var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCymbioLogoOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 126.92 135.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1161.67,
    y1: 10061.52,
    x2: -1037.87,
    y2: 10061.52,
    gradientTransform: "translate(1161.67 -9957.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e119b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c03ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 8518.21,
    y1: 62.79,
    x2: 8641.99,
    y2: 62.79,
    gradientTransform: "translate(8645.13 93.52) rotate(180)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.21,135a72.52,72.52,0,0,1-60-31.83L0,98.48,36.62,73.55l3.19,4.72A28.21,28.21,0,0,0,87,77.64l9.58,6.09a39.56,39.56,0,0,1-62.65,5.39L16,101.34a61.13,61.13,0,0,0,98.32-5.25l9.48,6.25A72.37,72.37,0,0,1,63.21,135Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.3,61.46l-3.19-4.72a28.2,28.2,0,0,0-47.19.64l-9.58-6.09A39.55,39.55,0,0,1,93,45.9l18-12.22a61.14,61.14,0,0,0-98.32,5.24L3.14,32.68a72.5,72.5,0,0,1,120.6-.84l3.18,4.69Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCymbioLogoOnly);
export default __webpack_public_path__ + "static/media/cymbio-logo-only.6f85a10fa99d596a215fd2199a141fb6.svg";
export { ForwardRef as ReactComponent };